import React, { createContext, useState, useContext, ReactNode } from "react";
import { Toast, ToastState, ToastVariants } from "src/components";

type ShowToastProps = {
  message: string;
  variant: ToastVariants;
};

interface ToastContextProps {
  showToast: (props: ShowToastProps) => void;
}

const ToastContext = createContext<ToastContextProps>({
  showToast: () => {},
});


export function useToast() {
  return useContext(ToastContext);
}


export function ToastProvider({ children }: { children: ReactNode }) {
  const [snackbarKey, setSnackbarKey] = useState(0);
  const [toastState, setToastState] = useState<ToastState>({
    open: false,
    message: "",
    variant: "warning",
  });

  const showToast = ({ message, variant }: ShowToastProps) => {
    setSnackbarKey((prev) => prev + 1);
    setToastState({
      open: true,
      message,
      variant,
    });
  };

  const handleClose = () => {
    setToastState((prev) => ({ ...prev, open: false }));
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast
        key={snackbarKey}
        open={toastState.open}
        message={toastState.message}
        variant={toastState.variant}
        onClose={handleClose}
      />
    </ToastContext.Provider>
  );
}
